import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { NotificationAlerts } from 'app/df-management/shared/df-management-alerts.model';
import { DfManagementService } from 'app/df-management/shared/df-management.service';
import { NotificationsService } from 'app/df-management/shared/notifications.service';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-notification-alert',
  templateUrl: './notification-alert.component.html',
  styleUrls: ['./notification-alert.component.scss'],
})
export class NotificationAlertComponent implements OnInit {
  notifications: NotificationAlerts[] = [];
  @Input() countryCode: string;
  @Input() customOverlayClass: string;
  isPopupVisible!: Observable<boolean>;
  loading = false;

  constructor(private notificationService: NotificationsService,
    private dfManagementService: DfManagementService
  ) { }

  closePopup(): void {
    this.notificationService.close();
  }

  ngOnInit(): void {
    this.isPopupVisible = this.notificationService.isPopupVisible;
    this.fetchNotifications();
  }

  fetchNotifications(): void {
    if (this.countryCode) {
      this.loading = true;
      this.dfManagementService.getNotificationsAlerts(this.countryCode).subscribe(
        (notifications: any[]) => {
          this.notifications = notifications.map(NotificationAlerts.fromDto);
          this.loading = false;
        },
        (error) => {
          console.error('Error fetching notifications:', error);
          this.loading = false;
        }
      );
    } else {
      console.warn('No country code selected.');
    }
  }



  calculatePopupHeight(): number {
    const baseHeight = 100;
    const notificationHeight = 50;
    const additionalHeight = this.notifications.length * notificationHeight;

    return baseHeight + additionalHeight;
  }

}

